import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import "./styles.scss";
function EngagementNotesDataModal(props) {
  const {engagementData} = props;
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="modalHeading">ENGAGEMENT NOTES DETAILS</Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={()=>props.setModalVisibility(false)}
            />
            <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",width:"130px"}}>Close Window</span>
            </div>
          </Modal.Header>
          <Modal.Body>
          <div className="session-detailsModal">
              <div className="col-md-10 session-detailwhole">
                <table id="session">
                  <tbody>
                  <tr>
                  <td className="session-question">
                        <p>SUMMARY</p>
                      </td>
                      <td className="session-answer">
                        {/* <p>
                         {engagementData?.engagementSummary}
                        </p> */}
                        {
                           engagementData?.engagementSummary.length > 116 ? (
                            <>
                            <div className="d-flex" style={{flexDirection:"row"}}>
                              <div className="goalText">
                            {engagementData?.engagementSummary.slice(0, 116)}
                            </div>
                            <div className="tooltipicon" style={{display:"flex",alignItems:"flex-end",cursor:"pointer"}}>
                            <b>...</b>
                            <span
                              className="tooltiptext7"
                              style={{ top: "-115px", left: "98px" }}
                            >
                              <h5 style={{ color: "#fff" }}>
                              ENGAGEMENT SUMMARY
                              </h5>
                              {engagementData?.engagementSummary}
                            </span>
                            </div>
                            </div>
                           
                            </>
                        ):<div className="goalText">{engagementData?.engagementSummary}</div>
                        }
                      </td>
                      </tr>
                      <tr>
                <td className="session-question"><p>DOCUMENT</p></td>
              {
                 engagementData?.supportingFile !== null ? (
<td className="session-answer">
                  <div className="modalButtonDoc">
                <a
              text="View Document"
              target="_blank"
              href={engagementData?.supportingFile}
            >
             View Document
            </a>
            </div>
                </td>
                 ):(
                    <td style={{fontFamily:"Montserrat",fontSize:"18px"}}>NA</td>
                 )
              }
              </tr>
                </tbody>
                </table>
                </div>
                </div>
            </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex justify-between sessionFooterFix">
            <div className="newuserTooltip top-btn">
              <Button
              onClick={()=>props.setModalVisibility(false)}
              text="CLOSE"
                  className="modalButton51 doc-upload"
                ></Button>
<span className="tooltiptext   tooltip-bottom" style={{top:"65px",left:"100px",width:"auto",height:"25px"}}>
                      Close window
                    </span>
              </div>
              </div>
             
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {})(withRouter(EngagementNotesDataModal));
